export const calcPlaceFromDiagonal = (apiClient) => {
    return {
        build(params) {
            return apiClient.request('/standard/calcPlaceFromDiagonal', params);
        },
    };
};
